export enum UserStatus {
	active = 'active',
	inactive = 'inactive',
	invited = 'invited',
  pending = 'pending'
}